var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgSnapchat(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "1 1 22 22",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.343 4.731c-.55 1.309-.333 3.653-.245 5.292-.594.35-1.356-.264-1.788-.264-.45 0-.985.314-1.07.78-.06.338.082.828 1.101 1.256.394.165 1.332.36 1.55.903.305.763-1.568 4.286-4.509 4.8a.452.452 0 0 0-.282.175.505.505 0 0 0-.1.33c.052.95 2.056 1.321 2.944 1.467.09.13.164.682.28 1.101.053.188.188.413.534.413.452 0 1.203-.37 2.51-.14C8.55 21.07 9.754 23 12.067 23c2.15 0 3.432-1.938 4.666-2.156.714-.126 1.327-.086 2.013.056.472.099.896.153 1.03-.34.119-.425.19-.965.28-1.093.88-.145 2.893-.516 2.943-1.465a.505.505 0 0 0-.1-.33.452.452 0 0 0-.281-.175c-2.891-.506-4.82-4.018-4.508-4.8.216-.542 1.147-.735 1.549-.903.746-.313 1.12-.697 1.112-1.142-.01-.57-.656-.91-1.13-.91-.483 0-1.177.608-1.74.279.089-1.653.305-3.986-.244-5.294C16.617 2.252 14.302 1 11.988 1 9.69 1 7.392 2.234 6.343 4.731Z",
    fill: "#000"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSnapchat);
export default __webpack_public_path__ + "static/media/snapchat.d8ea7f91a68f319388e733b9745fbe6f.svg";
export { ForwardRef as ReactComponent };